<div class="modal-header flex-shrink-0">
  <h4 class="modal-title">
    {{'shareProjectPopup.title' | translate}}: {{preselectedFriendSharedInfo?.username}}
  </h4>
</div>
<div class="modal-body pt-0 d-flex flex-column">
  <div class="fixed-fluid flex-grow-1">
    <div class="dialog-panel ps-0 fluid d-flex flex-column">
      <div class="wrapper-scroll-y">
        <table class="folder-project-table table table-hover mb-0">
          <thead>
            <tr class="c-default no-text-selection">
              <td class="b" colspan="4">{{'sharedUserRightsPopup.header.project_configuration' | translate}}</td>
              <td class="b">{{'sharedUserRightsPopup.header.read_right_column' | translate}}</td>
              <td class="b">{{'sharedUserRightsPopup.header.edit_right_column' | translate}}</td>
            </tr>
          </thead>
          <tbody>
            <ng-template ngFor let-item [ngForOf]="viewItems">
              <tr class="table-secondary c-default no-text-selection">
                <td colspan="4">
                  <ol class="dialog-breadcrumb verlical-center">
                    <li>{{
                      (item.navigationChain.length > 0 && item.navigationChain[0].userId === userID)
                      || (item.configurationGroups.length > 0 && item.configurationGroups[0].userId === userID) ?
                      ('projectNavigation.my_projects' | translate) : ('projectNavigation.shared_projects_with_user' | translate :{ '0':
                      item.configurationGroups[0]?.username ?  item.configurationGroups[0]?.username : item.navigationChain[0]?.username })
                    }}</li>
                    <ng-template ngFor let-projectGroup [ngForOf]="item.navigationChain" let-i="index">
                      <li [class.active]="i === (item.navigationChain.length - 1)">{{ projectGroup.groupName }}</li>
                    </ng-template>
                  </ol>
                </td>
                <td>
                  <i class="mdi" [class.mdi-check]="item.navigationChain[item.navigationChain.length - 1]?.isSharedReadOnly !== null"></i>
                </td>
                <td>
                  <i class="mdi" [class.mdi-check]="item.navigationChain[item.navigationChain.length - 1]?.isSharedReadOnly !== null && !item.navigationChain[item.navigationChain.length - 1]?.isSharedReadOnly"></i>
                </td>
              </tr>
              <ng-template ngFor let-configurationGroup [ngForOf]="item.configurationGroups">
                <tr class="no-text-selection">
                  <td width="20"></td>
                  <td class="folder-project-icon project" tooltip
                    [tooltipText]="'projectNavigation.tooltip.shared_project_user' | translate : { '0': configurationGroup.username }"
                    [tooltipDisabled]="!isUserHasPermissionToReadSharedInfo()"
                    tooltipPosition="bottom"
                  >
                    <app-svg-icon [type]="getEntryIcon(configurationGroup)" class="m-2"/>
                  </td>
                  <td>
                    <span class="folder-project-name" tooltip
                    [tooltipText]="'projectNavigation.tooltip.shared_project_user' | translate : { '0': configurationGroup.username }"
                    [tooltipDisabled]="!isUserHasPermissionToReadSharedInfo()"
                    tooltipPosition="bottom"
                    >{{configurationGroup.groupName}}</span>
                  </td>
                  <td class="folder-project-name c-default">
                    <span *ngIf="configurationGroup.groupType === PROJECT_FOLDER_TYPE && configurationGroup.options[0]?.value">
                      {{configurationGroup.options[0].value}}
                    </span>
                  </td>
                  <td>
                    <i class="mdi" [class.mdi-check]="configurationGroup.isSharedReadOnly !== null"></i>
                  </td>
                  <td>
                    <i class="mdi" [class.mdi-check]="configurationGroup.isSharedReadOnly !== null && !configurationGroup.isSharedReadOnly"></i>
                  </td>
                </tr>
                <tr class="no-text-selection" *ngFor="let projectHead of configurationGroup.projects">
                  <td></td>
                  <td class="text-end" tooltip
                    [tooltipText]="'projectNavigation.tooltip.shared_project_user' | translate : { '0': configurationGroup.username }"
                    [tooltipDisabled]="!isUserHasPermissionToReadSharedInfo()"
                    tooltipPosition="bottom"
                  >
                    <app-svg-icon type="configuration" size="medium-small" class="m-1 ms-4"/>
                  </td>
                  <td>
                    <span tooltip
                    [tooltipText]="'projectNavigation.tooltip.shared_project_user' | translate : { '0': configurationGroup.username }"
                    [tooltipDisabled]="!isUserHasPermissionToReadSharedInfo()"
                    tooltipPosition="bottom"
                    >{{projectHead.name}}</span>
                  </td>
                  <td>{{projectHead.articleNumberLong.reducedArticleNumberLong}}</td>
                  <td>
                    <i class="mdi" [class.mdi-check]="projectHead.isSharedReadOnly !== null"></i>
                  </td>
                  <td>
                    <i class="mdi" [class.mdi-check]="projectHead.isSharedReadOnly !== null && !projectHead.isSharedReadOnly"></i>
                  </td>
                </tr>
              </ng-template>
            </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer flex-shrink-0">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="onCancel()">{{'global.label.close' | translate}}</button>
</div>
